// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__s2Xuz","spinner":"styles_spinner__LsqiM"};